var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"200px"}},[_c('a',{attrs:{"href":"https://oss.baigongbao.com/2023/12/15/wbRQn4QcTN.docx","download":"wbRQn4QcTN.docx","target":"_blank"}},[_vm._v("打开链接")])])
}]

export { render, staticRenderFns }